import { Price, Token } from '@kodiak-finance/sdk-core'
import { tickToPrice } from '@kodiak-finance/v3-sdk'

export function getTickToPrice(baseToken?: Token, quoteToken?: Token, tick?: number): Price<Token, Token> | undefined {
  if (!baseToken || !quoteToken || typeof tick !== 'number') {
    return undefined
  }
  return tickToPrice(baseToken, quoteToken, isNaN(tick) ? 0 : tick)
}
